// @flow
import React from "react";
import cx from "classnames";
import styles from "./LongCaption.scss";

type LongCaptionProps = {
  caption: string,
  marginSize: "s" | "m"
};

const LongCaption = ({ caption, marginSize }: LongCaptionProps) => (
  <div className={cx(styles.caption, { [styles.marginSmall]: marginSize === "s" })}>{caption}</div>
);

LongCaption.defaultProps = {
  marginSize: "m"
};

export default LongCaption;
